
// SEO configurations for main pages
export const pageSEOConfig = {
  home: {
    title: "Standard Financial Group | Fayetteville GA Insurance Agency",
    description: "Local insurance agency in Fayetteville, GA offering affordable auto, home, commercial insurance & surety bonds since 1989.",
    keywords: "Standard Financial Group, insurance Fayetteville GA, cheap car insurance, cheap auto insurance, affordable insurance, best insurance agency Fayetteville GA, local insurance agency, cheap insurance quotes"
  },
  about: {
    title: "About Our Fayetteville GA Insurance Agency | Standard Financial Group",
    description: "Family-owned insurance agency serving Fayetteville and surrounding areas since 1989. Meet our team of experienced insurance professionals.",
    keywords: "Standard Financial Group, insurance Fayetteville GA, cheap car insurance, cheap auto insurance, affordable insurance, insurance agency history, insurance agents Fayetteville GA"
  },
  service: {
    title: "Insurance Services in Fayetteville GA | Standard Financial Group",
    description: "Comprehensive insurance services from a trusted local agency. Auto, home, commercial insurance and surety bonds.",
    keywords: "Standard Financial Group, insurance Fayetteville GA, cheap car insurance, cheap auto insurance, affordable insurance, insurance services, insurance agency services"
  },
  products: {
    title: "Insurance Products in Georgia | Standard Financial Group",
    description: "Comprehensive insurance products including auto, home, commercial and surety bonds. Compare rates from multiple carriers.",
    keywords: "Standard Financial Group, insurance Fayetteville GA, cheap car insurance, cheap auto insurance, affordable insurance, insurance products Georgia, insurance coverage options"
  },
  quote: {
    title: "Free Insurance Quote in Georgia | Standard Financial Group",
    description: "Get a free insurance quote from multiple carriers. Compare rates for auto, home, and commercial insurance in Fayetteville, GA.",
    keywords: "Standard Financial Group, insurance Fayetteville GA, cheap car insurance, cheap auto insurance, affordable insurance, free insurance quote Fayetteville GA, compare insurance rates Georgia"
  },
  contact: {
    title: "Contact Our Fayetteville GA Insurance Agency | Standard Financial Group",
    description: "Contact our insurance agents in Fayetteville, GA. Visit our office, call us, or submit a contact form for assistance with your insurance needs.",
    keywords: "Standard Financial Group, insurance Fayetteville GA, cheap car insurance, cheap auto insurance, affordable insurance, insurance agent contact, insurance office Fayetteville GA"
  },
  blog: {
    title: "Insurance Blog & Resources | Standard Financial Group",
    description: "Insurance tips, guides, and industry news from Standard Financial Group. Stay informed about insurance trends and coverage options.",
    keywords: "Standard Financial Group, insurance Fayetteville GA, cheap car insurance, cheap auto insurance, affordable insurance, insurance blog, insurance tips, insurance guides"
  },
  privacy: {
    title: "Privacy Policy | Standard Financial Group Insurance Agency",
    description: "Standard Financial Group's privacy policy. Learn how we collect, use, and protect your personal information.",
    keywords: "Standard Financial Group, insurance Fayetteville GA, cheap car insurance, cheap auto insurance, affordable insurance, privacy policy, insurance agency privacy"
  },
  agentLogin: {
    title: "Agent Login Portal | Standard Financial Group",
    description: "Secure portal for Standard Financial Group agents. Access client information, quotes, and policy management tools.",
    keywords: "Standard Financial Group, insurance Fayetteville GA, cheap car insurance, cheap auto insurance, affordable insurance, agent login, insurance agent portal"
  },
  notFound: {
    title: "Page Not Found (404) | Standard Financial Group",
    description: "The page you're looking for cannot be found. Return to Standard Financial Group's homepage for insurance solutions.",
    keywords: "Standard Financial Group, insurance Fayetteville GA, cheap car insurance, cheap auto insurance, affordable insurance"
  },
  sitemap: {
    title: "Site Map | Standard Financial Group Insurance Agency",
    description: "Complete listing of all pages on the Standard Financial Group insurance website. Find the insurance information you need.",
    keywords: "Standard Financial Group, insurance sitemap, insurance website map, insurance agency pages, Fayetteville GA insurance"
  }
};
